import React from "react";
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { StaticImage } from 'gatsby-plugin-image';

import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LanguageIcon from '@mui/icons-material/Language';
import PublicIcon from '@mui/icons-material/Public';

import B from '@components/bold-text';
import GoogleAds from '@components/advertising/googleAds';
import Informer from '@components/informer';

import Layout from '@components/layout';
import P from '@components/paragraph';
import Subheader from '@components/subheader';
import theme from '@components/theme';

import { cleanPhone, cleanLink } from '@utils/clean';
import embassy from '@data/moldova-embassies/czechia.json';

const l10nPages = {
  ru: '/ru/posolstvo/chekhiya',
  ro: '/ro/ambasada/cehia',
  en: '/en/embassy/czech',
};

const iconStyle = {
  background: theme.pallete.secondary,
  color: '#fff',
  p: '4px',
  borderRadius: '50%',
  fontSize: '20px',
  mr: '12px'
}

const mideiHotLine = '+373 22 690-990';
const checkDate = 'November 1, 2022';

export default function Page() {
  return (
    <Layout
      title="Embassy of Moldova in Czech Republic, Prague"
      l10nPages={l10nPages}
      description="Embassy of Moldova in Czech Republic, Prague. The address and telephone number of the embassy. Schedule. How to make an appointment online."
    >
      <Container>
        <h1>Embassy of Moldova in Czech Republic, Prague</h1>

        <Subheader>Verified: {checkDate}</Subheader>
      </Container>

      
      <img
        alt="Embassy of Moldova in Czech Republic, Prague"
        src="/images/embassies/cehia.jpg"
      />


      <Container>
        <h2>Contacts</h2>

        <List>
          <ListItem disableGutters>
            <AlternateEmailIcon sx={iconStyle} />

            <ListItemText>
              <B>Email:</B>
              <Link sx={{ pl: '5px' }} target="_blank" href={`mailto:${embassy.email}`}>{embassy.email}</Link>
            </ListItemText>
          </ListItem>

          <ListItem disableGutters>
            <LanguageIcon sx={iconStyle} />

            <ListItemText>
              <B>Official site:</B>
              <Link sx={{ pl: '5px' }} target="_blank" href={embassy.site}>{cleanLink(embassy.site)}</Link>
            </ListItemText>
          </ListItem>

          <ListItem disableGutters>
            <PublicIcon sx={iconStyle} />

            <ListItemText>
              <B>Social networks:</B>
              <Link sx={{ pl: '5px' }} target="_blank" href={embassy.fb}>Facebook</Link>
            </ListItemText>
         </ListItem>
        </List>
        
        <h2>Address</h2>

        <P>
          <B>Embassy address:</B> {embassy.address} (<Link target="_blank" href={embassy.map}>see on the map</Link>)
        </P>

        
        
        <h2>How to receive a consultation</h2>

        <Informer
          label={
            <Link
              target="_blank"
              href={`tel:${cleanPhone(embassy.phones[0].phone)}`}
            >
              {embassy.phones[0].phone}
            </Link>
          }
          text="Phone number of the consular section of the Embassy of Moldova in Czech Republic, Prague"
        />

        <P>You can contact by phone  (call for consultations on work days from  14:00 to 16:00). If the schedule for receiving calls is inconvenient for you, you can send an email describing your problem to the email address: <Link target="_blank" href={`mailto:${embassy.email}`}>{embassy.email}</Link>. Also, you can call the hotline of the Ministry of Foreign Affairs of Moldova at <Link target="_blank" href={`tel:${cleanPhone(mideiHotLine)}`}>{mideiHotLine}</Link> from 8:00 to 17:00 on weekdays, <B>Moldova time</B>.
        </P>

        <GoogleAds />
        
        <h2>Online booking</h2>

        <P>The consular department has the <Link target="_blank" href={embassy.book}>online appointment</Link>. If there is no need for a preliminary consultation, then you can immediately sign up online. When registering, you can choose a convenient time for visiting.
        </P>
    
        
        <h2>In emergency situations</h2>

        <Informer
          label={
            <Link
              target="_blank"
              href={`tel:${cleanPhone(embassy.hotLine.phone)}`}
            >
              {embassy.hotLine.phone}
            </Link>
          }
          color="red"
          text="Hotline of the Moldovan Embassy in Czech Republic, Prague"
        />
        <P>In case of emergency, you can call the embassy hotline number. Emergency situations mean: death, arrest, loss or theft of documents of a citizen of Moldova. You can call this phone number <B>24/7</B>, but you can not consult and make an appointment.</P>

        <h2>Schedule</h2>

        <P>From Monday to Friday, except for the official holidays of the Republic of Moldova, from 08:00 to 17:00. The working day of the consular department is divided into several parts with different tasks (issuing documents, receiving citizens, etc.). Details of the schedule can be obtained on the website of the embassy and by phone.</P>

      </Container>
    </Layout>
  )
}